import { change, changeSamples, checkInput, checkOtherOptions, changeSample, updateField, touchAllFields, clickAccordion } from './actions/actions'

export default function mapDispatchToProps(dispatch) {
    return {
        actions: {
            change: () => { dispatch(change()) },
            changeSamples: (samples) => { dispatch(changeSamples(samples))},
            checkInput: (index, inputName, checked) => { dispatch(checkInput(index, inputName, checked))},
            checkValid: () => { dispatch(checkValid())},
            touchAllFields: () => { dispatch(touchAllFields())},
            updateField: (name, value) => { dispatch(updateField(name,value))},
            checkOtherOptions: (inputName, checked) => { dispatch(checkOtherOptions(inputName, checked))},
            changeSample: (index, sample) => { dispatch(changeSample(index, sample))},
            clickAccordion: (index, checked) => { dispatch(clickAccordion(index, checked))}
        }
    }
}